@if (statement) {
  <div class="epic_statement_card">
    <div class="epic_statement_card_head_wrap">
      <div class="epic_statement_card_head">
        {{ statement.getFullname() }}
      </div>
      <progress max="100" [value]="statement | statementProgressPipe"></progress>
    </div>
    <div class="epic_statement_card_cont_wrap">
      <div class="label_title">{{ "CARD.REFUND_DETAILS" | translate }}</div>
      <div class="refund" (click)="openRefundDetailsDialog()">
        <div
          class="refund_value"
          [class.green]="statement.estimatedRefund > 0"
          [class.red]="statement.estimatedRefund < 0"
          [class.grey]="
            statement.serviceType === 'tax_adviser' &&
            (statement.status === 'paid' || statement.status === 'paid_ready')
          "
        >
          @if (statement.estimatedRefund < 0) {
            <span>-</span>
          }
          &euro; {{ statement.getAbsoluteRefund() }}
        </div>
      </div>
      <div class="epic_statement_card_info" [class.custom]="!statement.clonedFrom">
        <div class="single_info">
          <div class="label_title sm_m">{{ "CARD.DATE_TITLE" | translate }}</div>
          <div class="desc_title">{{ statement.createdDate }}</div>
        </div>
        @if (statement.clonedFrom) {
          <div class="single_info">
            <div class="label_title sm_m">{{ "CARD.CLONED_TITLE" | translate }}</div>
            <div class="desc_title">ID: {{ statement.clonedFrom }}</div>
          </div>
        }
        <div class="single_info status">
          <div class="label_title sm_m">{{ "CARD.STATUS_TITLE" | translate }}</div>
          <div class="desc_title">
            <span class="status_txt" [innerHTML]="getDashboardStatus() | translate">
              <!-- {{ }} -->
              <!-- {{ statement.statusText }} -->
            </span>
            @if (statement.dashboardStatus === "ORDERED") {
              <app-more-info-tooltip
                [isXSmallIcon]="true"
                [message]="'TOOLTIP.DASHBOARD_ORDERED'"
                [showText]="false"
              ></app-more-info-tooltip>
            }
            @if (statement.dashboardStatus === "IN_APPROVAL") {
              <app-more-info-tooltip
                [isXSmallIcon]="true"
                [message]="'TOOLTIP.DASHBOARD_IN_APPROVAL'"
                [showText]="false"
              ></app-more-info-tooltip>
            }
            @if (statement.dashboardStatus === "SUBMITTED") {
              @if (statement.hasCertificate) {
                <app-more-info-tooltip
                  [isXSmallIcon]="true"
                  [message]="'TOOLTIP.DASHBOARD_SUBMITTED_CERTIFICATE'"
                  [showText]="false"
                ></app-more-info-tooltip>
              }
              @if (!statement.hasCertificate) {
                <app-more-info-tooltip
                  [isXSmallIcon]="true"
                  [message]="'TOOLTIP.DASHBOARD_SUBMITTED_NO_CERTIFICATE'"
                  [showText]="false"
                ></app-more-info-tooltip>
              }
            }
          </div>
        </div>
        <div class="single_info t_right">
          <div class="label_title sm_m">{{ "CARD.PROGRESS_TITLE" | translate }}</div>
          <div class="desc_title"
            ><b>{{ getDashboardFinishPrecent() }}%</b></div
          >
        </div>
      </div>
      <!--TAX-2611-->
      <!--        <div>-->
      <!--            <div class="single_info" *ngIf="steuerSendDate">-->
      <!--                <div class="label_title sm_m">{{ 'CARD.TAX_ADVISER_WILL_SEND_IN_DAYS' | translate }}</div>-->
      <!--                <div class="desc_title">{{ steuerSendDate }}</div>-->
      <!--            </div>-->
      <!--        </div>-->
    </div>
    <div class="epic_statement_card_bottom_wrap">
      @if (!statement.isSent() && isRabeEnabledForStatement) {
        <button
          class="btn_icon btn_icon--attach-rabe"
          mat-button
          [attr.data-cy]="'btnSendRabeStatement'"
          [disabled]="statement.isProcessing()"
          (click)="openSendRabeDialogComponent()"
        >
          <i class="fa fa-upload attach-rabe-icon" aria-hidden="true"></i>
          <span i18n>{{ "COMMON.ATTACH_DOCUMENTS" | translate }}</span>
        </button>
      }
      @if (statement.isSent() && rabeAttachmentsCount > 0 && isRabeEnabledForStatement) {
        <button
          class="btn_icon btn_icon--attach-rabe"
          mat-button
          [attr.data-cy]="'btnPreviewRabeStatement'"
          (click)="openRabeAttachmentListDialogComponent()"
        >
          <i class="fa fa-cloud attach-rabe-icon" aria-hidden="true"></i>
          <span i18n>{{ "COMMON.DOCUMENTS" | translate }} ({{ rabeAttachmentsCount }})</span>
        </button>
      }
      @if (statement.hasOpenDocumentRequest && statement.isPremiumPackage && !isTaxAdviser && !isBusiness) {
        <button class="btn_icon btn_icon--document-request" mat-button (click)="openDocumentRequestDialog()">
          <i class="fa fa-upload attach-doc-request-icon" aria-hidden="true"></i>
          <span>{{ "DOCUMENT_REQUEST.TILE_BUTTON" | translate }}</span>
        </button>
      }
      @if (
        !hideEditing &&
        !statement.isSent() &&
        !statement.isForClientApproval &&
        !statement.isReportedErrors &&
        !statement.isApproved
      ) {
        <button
          class="btn_icon"
          mat-button
          [attr.data-cy]="'btnEditStatementB2C'"
          (click)="editStatement()"
          [disabled]="
            statement.isProcessing() ||
            (statement.status === 'paid_ready' && statement.serviceType === 'tax_adviser' && !isTaxAdviser)
          "
        >
          <img src="../../../assets/svg/edit_icon.svg" alt="edit" />
          <span>{{ "COMMON.EDIT" | translate }}</span>
        </button>
      }
      @if (!hideEditing && !statement.isSent() && statement.isForClientApproval) {
        <button
          class="btn_icon"
          mat-button
          (click)="editStatement()"
          [attr.data-cy]="'btnConfirmStatementB2C'"
          [disabled]="
            statement.isProcessing() ||
            (statement.status === 'paid_ready' && statement.serviceType === 'tax_adviser' && !isTaxAdviser)
          "
        >
          <img src="../../../assets/svg/checkout_check.svg" alt="edit" />
          <span>{{ "COMMON.CONFIRM" | translate }}</span>
        </button>
      }
      @if (!hideInvoice && statement.isPaid) {
        <button
          class="btn_icon"
          mat-button
          [class.is-loading]="statement.downloadingInvoice"
          [disabled]="statement.downloadingInvoice"
          (click)="emitDownloadInvoice()"
        >
          <img src="../../../assets/svg/upload_pdf.svg" alt="invoice" />
          <span i18n>{{ "COMMON.INVOICE" | translate }}</span>
        </button>
      }
      <!-- <button
    class="btn_icon"
    mat-button
    [class.is-loading]="statement.downloadingPdf"
    [disabled]="statement.downloadingPdf"
    *ngIf="!hidePdf && statement.canDownloadPdf"
    (click)="emitDownloadPdf()"
    >
    <img src="../../../assets/svg/download.svg" alt="download" />
    <span i18n>{{ "COMMON.FORM" | translate }}</span>
  </button> -->
      @if (displayDownloadsButton() && statement.numberOfAttachments > 0) {
        <button
          class="btn_icon downloads"
          mat-button
          title="Downloads"
          i18n-title="Downloads"
          (click)="emitShowDownloadDialog()"
        >
          <span>{{ statement.numberOfAttachments }}</span>
          <img src="../../../assets/svg/download.svg" alt="download" />
        </button>
      }
      @if (statement.isSent()) {
        <button class="btn_icon" mat-button (click)="emitCloneStatment()">
          <img src="../../../assets/svg/duplicate.svg" alt="clone" />
          <span i18n>{{ "COMMON.CLONE" | translate }}</span>
        </button>
      }
      @if (!hideRemoving && !(statement.isProcessing() || statement.isSent() || statement.isPaid)) {
        <button
          class="btn_icon red"
          mat-button
          [class.is-loading]="statement.deleting"
          [disabled]="statement.deleting"
          (click)="emitDeleteStatement()"
          [attr.data-cy]="'btnDeleteStatement'"
        >
          <img src="../../../assets/svg/del_icon.svg" alt="delete" />
          <span i18n>{{ "COMMON.CARD_DELETE" | translate }}</span>
        </button>
      }
      @if (shouldShowHamburgerMenu) {
        <app-mini-hamburger-menu [template]="hamburgerElements"></app-mini-hamburger-menu>
      }
    </div>
    <ng-template #hamburgerElements>
      @if (shouldShowLegacyEwrAttachmentButton) {
        <button
          class="btn_icon hamburger-button"
          mat-button
          [class.is-loading]="statement.deleting"
          [disabled]="statement.deleting"
          (click)="openSaveEwrDialogComponent()"
          [attr.data-cy]="'btnAttachLegacyEwr'"
        >
          <span i18n>{{ "COMMON.ATTACH_EWR" | translate }}</span>
        </button>
      }
      @if (statement.isSent()) {
        <button
          class="btn_icon hamburger-button"
          mat-button
          [class.is-loading]="statement.deleting"
          [disabled]="statement.deleting"
          (click)="openAppealDecisionDialogComponent()"
          [attr.data-cy]="'btnDeleteStatement'"
        >
          <span i18n>{{ "COMMON.SEND_APPEAL" | translate }}</span>
        </button>
      }
      @if (statement.isSent()) {
        <button
          class="btn_icon hamburger-button"
          mat-button
          [class.is-loading]="statement.deleting"
          [disabled]="statement.deleting"
          (click)="openSendNewMessageDialogComponent()"
          [attr.data-cy]="'btnDeleteStatement'"
        >
          <span i18n>{{ "COMMON.SEND_MESSAGE" | translate }}</span>
        </button>
      }
      @if (statement.isSent() && !isTaxAdviser) {
        <button
          class="btn_icon hamburger-button"
          mat-button
          [class.is-loading]="statement.deleting"
          [disabled]="statement.deleting"
          (click)="openSendAttachmentDialogComponent()"
          [attr.data-cy]="'btnDeleteStatement'"
        >
          <span i18n>{{ "COMMON.SEND_ATTACHMENT" | translate }}</span>
        </button>
      }
      @if (statement.isSent()) {
        <button
          class="btn_icon hamburger-button"
          mat-button
          [class.is-loading]="statement.deleting"
          [disabled]="statement.deleting"
          (click)="openSendEwrDialogComponent()"
          [attr.data-cy]="'btnDeleteStatement'"
        >
          <span i18n>{{ "COMMON.SEND_EWR" | translate }}</span>
        </button>
      }
    </ng-template>
  </div>
}
